import { authHeader } from '../_core/auth-header';
import Config from '../_core/config';
import { v4 as uuidv4 } from 'uuid';


export const cartService = {
    getItems,
    addItem,
    removeItem,
    clearCart,
    //fetchNonce,
    addToCart,
    getAllCart,
    removeFromCart,
    updateCartItemQuantity
};

function getItems(page, perPage) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    let cart = localStorage.getItem('cart');

    if(cart===null){
        cart = uuidv4();
        localStorage.setItem('cart', cart);
    }

    return fetch(Config.api.basepath+`/cart/` + cart, requestOptions)
        .then(handleResponse)
        .then(
            result => {
                if(result){
                    let cart = result.cart
                    let subtotal = 0.00;
                    if(cart.items && cart.items.length > 0){
                        for(let i in cart.items){
                            subtotal = (parseFloat(subtotal) + ( parseFloat(cart.items[i].c) * cart.items[i].q)).toFixed(2);
                        }
                    }

                    cart.id = result.uuid;
                    cart.subtotal = subtotal || 0;
                    cart.total = subtotal || 0;

                    return cart;
                }else{
                    return {
                        id: '',
                        subtotal:0.00,
                        total:0.00,
                        items: []
                    };
                }
            },
            error => {
                return {error: 'Fetch Post Error. Service Unavailable.'};
            }
        );
}

function addItem(items) {
    let cart = localStorage.getItem('cart');

    if(cart===null){
        cart = uuidv4();
        localStorage.setItem('cart', cart);
    }

    items.uuid = cart;

    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(items)
    };

    return fetch(Config.api.basepath+`/cart/`, requestOptions)
        .then(handleResponse)
        .then(
            cart => {
                sessionStorage.setItem("isCartUpdate", true);
                return { success: cart };
            },
            error => {
                return { error: 'Fetch Post Error. Service Unavailable.' };
            }
        );
}

function removeItem(items) {
    addItem(items);
}

function clearCart() {
    let cart = localStorage.getItem('cart');

    if(cart===null){
        cart = uuidv4();
        localStorage.setItem('cart', cart);
    }
    
    const requestOptions = {
        method: 'PUT',
        headers: authHeader()
    };

    return fetch(Config.api.basepath+`/cart/${cart}/clear`, requestOptions).then(handleResponse).then(() => sessionStorage.setItem("isCartUpdate", true))   
}


// function fetchNonce() {
//     const baseUrl = window.location.origin;
//     return fetch(`${baseUrl}/wp-json/my-custom/v1/nonce`)
//         .then(response => {
//             if (!response.ok) {
//                 throw new Error('Failed to fetch nonce');
//             }
//             return response.text(); // Ensure it returns the nonce as plain text
//         })
//         .then(data => {
//             console.log('Fetched nonce:', data); // Debug log
//             return data; // Return the fetched nonce
//         })
//         .catch(error => {
//             console.error('Error fetching nonce:', error);
//             throw error;
//         });
// }


let storeApiNonce = ''; // Define a variable to store the nonce

function getAllCart() {
    const baseUrl = window.location.origin;

    const headers = new Headers();
    headers.append('Content-Type', 'application/json');

    const requestOptions = {
        method: 'GET',
        headers: headers,
    };

    return fetch(`${baseUrl}/wp-json/wc/store/v1/cart`, requestOptions)
        .then(response => {
            if (!response.ok) {
                return response.json().then(errorData => {
                    console.error('Error response:', errorData);
                    throw new Error('Failed to fetch cart items');
                });
            }
            // Retrieve and save the X-WC-Store-Api-Nonce from the response headers
            storeApiNonce = response.headers.get('Nonce');
            return response.json();
        })
        .catch(error => {
            console.error('Error fetching cart items:', error);
            throw error;
        });
}

function addToCart(productId, quantity = 1) {
    const baseUrl = window.location.origin;

    const payload = {
        id: productId,
        quantity: quantity
    };

    //console.log(payload)
    //console.log(storeApiNonce)

    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Nonce', storeApiNonce); // Include the nonce in the headers

    const requestOptions = {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(payload)
    };

    return fetch(`${baseUrl}/wp-json/wc/store/v1/cart/items`, requestOptions)
        .then(response => {
            if (!response.ok) {
                return response.json().then(errorData => {
                    console.error('Error response:', errorData);
                    throw new Error('Failed to add product to cart');
                });
            }
            sessionStorage.setItem("isCartUpdate", true);
            return response.json();
        })
        .catch(error => {
            console.error('Error adding product to cart:', error);
            throw error;
        });
}


function removeFromCart(itemKey) {
    const baseUrl = window.location.origin;

    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Nonce', storeApiNonce); // Include the nonce in the headers

    const requestOptions = {
        method: 'DELETE',
        headers: headers
    };

    return fetch(`${baseUrl}/wp-json/wc/store/v1/cart/items/${itemKey}`, requestOptions)
        .then(response => {
            if (!response.ok) {
                return response.json().then(errorData => {
                    console.error('Error response:', errorData);
                    throw new Error('Failed to remove item from cart');
                });
            }
            // No need to parse JSON here, return the response directly
            return response;
        })
        .then(data => {
            console.log('Item removed from cart:', data);
            // Since there's no JSON data expected, return null or an empty object
            return data; // Change this if necessary
        })
        .catch(error => {
            console.error('Error removing item from cart:', error);
            throw error;
        });
}

function updateCartItemQuantity(itemKey, quantity) {
    const baseUrl = window.location.origin;

    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Nonce', storeApiNonce); // Include the nonce in the headers

    const requestOptions = {
        method: 'PUT', // Use 'PUT' or 'PATCH' as per the API documentation
        headers: headers,
        body: JSON.stringify({ quantity })
    };

    return fetch(`${baseUrl}/wp-json/wc/store/v1/cart/items/${itemKey}`, requestOptions)
        .then(response => {
            if (!response.ok) {
                return response.json().then(errorData => {
                    console.error('Error response:', errorData);
                    throw new Error('Failed to update cart item quantity');
                });
            }
            return response.json();
        })
        .then(data => {
            console.log('Cart item quantity updated:', data);
            return data;
        })
        .catch(error => {
            console.error('Error updating cart item quantity:', error);
            throw error;
        });
}

function handleResponse(response) {
    return response.text().then(text => {
        
        const data = text && JSON.parse(text);
        if (!response.ok) {

            let error = (data.error && data.details) || response.statusText;
            
            return Promise.reject(error);
        }

        return data;
    });
}
